import { ContentCluster } from '@app/components/base/content-structure/ContentCluster';
import { ExpandableProse } from '@app/components/base/content-structure/ExpandableProse';
import { Alert, Box } from '@mui/material';
import { FormattedMessage, MessageDescriptor } from 'react-intl';
import { VerifyMatchTranscriptionSkeleton } from './VerifyMatchTranscriptionSkeleton';

export interface VerifyMatchTextSectionProps {
  /** Cluster title above the prose body. */
  title: MessageDescriptor;
  /** Message shown when loading/error/empty leave no content. */
  emptyMessage: MessageDescriptor;
  content: string | null | undefined;
  isLoading: boolean;
  isError: boolean;
}

/**
 * Shared content cluster + loading / error / empty / text body for verify-dialog text panels.
 */
export function VerifyMatchTextSection({
  title,
  emptyMessage,
  content,
  isLoading,
  isError,
}: VerifyMatchTextSectionProps) {
  return (
    <ContentCluster message={title} divider={false}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {isLoading && !content && <VerifyMatchTranscriptionSkeleton />}
        {isError && !content && (
          <Alert severity="warning">
            <FormattedMessage {...emptyMessage} />
          </Alert>
        )}
        {!isLoading && !content && !isError && (
          <Alert severity="info">
            <FormattedMessage {...emptyMessage} />
          </Alert>
        )}
        {content && <ExpandableProse>{content}</ExpandableProse>}
      </Box>
    </ContentCluster>
  );
}
